<template>
    <div>
        <div v-if="authUserPermission['sap-sync-master-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col">
                                <h3 class="mb-0">{{ tt('sap_task_master') }}</h3>
                            </div>
                            <div class="col-6">
                                <base-input input-classes="form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search')" v-on:keyup="filter"/>
                            </div>
                            <div class="col text-right">
                                <base-button size="sm" type="default" @click="create" v-if="authUserPermission['sap-sync-master-create']">{{ tt('add_new') }}</base-button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('id')" :prop="tt('id')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.id}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('sync_name')" :prop="tt('sync_name')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.sync_name}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('connection_id')" :prop="tt('connection_id')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.connection_id}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('function_type')" :prop="tt('function_type')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    {{row.function_type}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('function')" :prop="tt('function')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.function}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('source_type')" :prop="tt('source_type')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.source_type}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('source')" :prop="tt('source')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.source}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('created_by')" :prop="tt('created_by')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.created_by}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('created_at')" :prop="tt('created_at')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    {{row.created_at}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}" v-if="authUserPermission['sap-sync-master-update']">{{ tt('edit') }}</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}" v-if="authUserPermission['sap-sync-master-delete']">{{ tt('delete') }}</el-dropdown-item> 
                                            <router-link :to="'/sap/sap-sync-params/'+row.id" class="dropdown-item ml-1" tag="button">{{ tt('sap_sync_params') }}</router-link>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <page-loading v-else/>
                    </div>
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>
                        <label class="form-control-label" v-if="form.add">{{ tt('id') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('id')" :placeholder="tt('id')" v-model="sapSyncMaster.id" rules="required" v-if="form.add"></base-input>

                        <label class="form-control-label">{{ tt('sync_name') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('sync_name')" :placeholder="tt('sync_name')" v-model="sapSyncMaster.sync_name" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('connection_id') }}</label>
                        <base-input :name="tt('connection_id')" :placeholder="tt('connection_id')" v-model="sapSyncMaster.connection_id" rules="numeric"></base-input>

                        <label class="form-control-label">{{ tt('function_type') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('function_type')" :placeholder="tt('function_type')" v-model="sapSyncMaster.function_type" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('function') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('function')" :placeholder="tt('function')" v-model="sapSyncMaster.function" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('source_type') }}</label>
                        <base-input :name="tt('source_type')" :placeholder="tt('source_type')" v-model="sapSyncMaster.source_type"></base-input>

                        <label class="form-control-label">{{ tt('source') }}</label>
                        <base-input :name="tt('source')" :placeholder="tt('source')" v-model="sapSyncMaster.source"></base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import sapSyncMaster from '@/services/sap/sapSyncMaster.service';

    export default {        
        data() {
            return { 
                onLoad: true, 
                loadTimeout: null, 
                errorMessage: null,
                btnSave: {
                    onLoading: false
                },                  
                form: {
                    add: true,
                    title: this.tt('add_sap_synchron_master'),
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },        
                sapSyncMaster: {}, 
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
        },
        methods: {
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            get() { 
                let context = this;               
                Api(context, sapSyncMaster.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data  = response.data.data.data.data;
                    context.table.page  = response.data.data.data;  
                    context.onLoad      = false;      
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data  = [];
                        context.table.total = 0;
                        context.onLoad      = false;
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add');
                this.form.show = true;
                this.sapSyncMaster = {};
            },
            edit(id) {
                this.errorMessage = null;
                let context       = this;   

                Api(context, sapSyncMaster.show(id)).onSuccess(function(response) {
                    context.sapSyncMaster = response.data.data;
                    context.form.add      = false;
                    context.form.title    = context.tt('edit');
                    context.form.show     = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api     = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, sapSyncMaster.create(this.sapSyncMaster));
                } else {{
                    if (this.sapSyncMaster.connection_id == '') {
                        context.sapSyncMaster.connection_id =  null;
                    }
                    api = Api(context, sapSyncMaster.update(this.sapSyncMaster.id, this.sapSyncMaster));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, sapSyncMaster.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
        }   
    };
</script>
<style></style>
